import React from 'react';
import { Button, Flex, List, ListIcon, ListItem, Text } from '@chakra-ui/react';
import { ReactComponent as Checkmark } from 'resources/images/checkmark.svg';
import { PricingPlan } from 'types/subscription.types';
import { getPrice } from 'app/utils/utils';

export interface SubscriptionPriceCardProps {
  pricing: PricingPlan;
  title: string;
  description?: string;
  attributes?: string[];
  onClick: (id: string) => void;
}

export const SubscriptionPriceCard: React.FC<SubscriptionPriceCardProps> = ({
  pricing,
  title,
  description,
  attributes,
  onClick,
}) => {
  return (
    <Flex
      direction="column"
      data-testid="subscription-price-card"
      maxWidth="273px"
      width="100%"
    >
      <Flex
        direction="column"
        bg="P.50"
        height="148px"
        width="100%"
        align="flex-start"
        justifyContent="center"
        borderRadius="4px"
        px={4}
      >
        <Text fontSize="lg" fontWeight={500} lineHeight="22px">
          {title}
        </Text>
        <Text fontSize="sm" data-testid="subscription-card-price">
          {getPrice(pricing.price, pricing.currency)}
          {pricing.interval === 'month' ? ' / month' : ' / year'}
        </Text>
      </Flex>
      {attributes && (
        <List pt={4}>
          {attributes.map((attr: string) => (
            <ListItem
              key={attr}
              display="flex"
              alignItems="center"
              _notLast={{ pb: 2 }}
            >
              <ListIcon as={Checkmark} color="M.60" marginEnd={0} />
              <Text pl={1} fontSize="xs" color="M.60" lineHeight="small">
                {attr}
              </Text>
            </ListItem>
          ))}
        </List>
      )}
      {!attributes && description && (
        <Text fontSize="xs" color="M.60" py={2}>
          {description}
        </Text>
      )}
      <Button
        mt={4}
        w="full"
        data-testid="selection-card-button"
        onClick={() => onClick(pricing.id)}
      >
        Continue
      </Button>
    </Flex>
  );
};
